<script>
export default {
  name: "support-icon",
  props: ["strokeColor"]
};
</script>
<template>
  <svg
    id="lock.3"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_1024" data-name="Group 1024">
      <path
        id="Path_8435"
        data-name="Path 8435"
        d="M17,21H7a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2H17a2,2,0,0,1,2,2v7A2,2,0,0,1,17,21ZM8,10V7H8a4,4,0,0,1,4-4h0a4,4,0,0,1,4,4h0v3"
        fill="none"
        :stroke="this.strokeColor ? this.strokeColor : '#323232'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_8436" data-name="Path 8436" d="M0,0H24V24H0Z" fill="none" />
  </svg>
</template>
